import { render, staticRenderFns } from "./ImportBulkItemUpdate.vue?vue&type=template&id=af5ad6a4&"
import script from "./ImportBulkItemUpdate.vue?vue&type=script&lang=js&"
export * from "./ImportBulkItemUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports